import {NovaTarefa} from "./nova-tarefa";
import {Comentario} from "./comentario";
import {MovimentacaoTarefa} from "./movimentacao-tarefa";

export class TarefaDetalhes extends NovaTarefa{
  id: number;
  responsavel: string;
  dataCadastro: Date;
  override status: number;
  processo: string;
  tipoTarefa: string;
  numeroProcesso: string;
  descricaoDetalhada: string;
  comentario: string;
  responsavelId: number;
  solicitanteId: number;
  atendimento: string;

  comentariosDetalhes: Comentario[];
  movimentacoesDetalhes: MovimentacaoTarefa[];
}
